import styled from '@emotion/styled'
import { type ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  description?: string
  /** Optional glyph/emoji or small icon node. */
  icon?: ReactNode
  /** Optional call-to-action (a Button or link). */
  action?: ReactNode
}

// EmptyState is the shared "nothing here yet" panel for empty catalogs, lesson
// lists, dashboards, etc. (KAT-297).
export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <Root>
      {icon && <Icon aria-hidden>{icon}</Icon>}
      <Title>{title}</Title>
      {description && <Body>{description}</Body>}
      {action && <Actions>{action}</Actions>}
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--s-3);
  padding: var(--s-9) var(--s-5);
  border: 1px dashed var(--c-border-strong);
  border-radius: var(--r-lg);
  background: var(--c-bg-elev);
  color: var(--c-fg-muted);
`

const Icon = styled.div`
  font-size: 28px;
  line-height: 1;
`

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--c-fg);
`

const Body = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  max-width: 42ch;
`

const Actions = styled.div`
  margin-top: var(--s-2);
`
